import { render, staticRenderFns } from "./FilesFieldTreeNode.vue?vue&type=template&id=65ca0197&scoped=true&"
import script from "./FilesFieldTreeNode.vue?vue&type=script&lang=js&"
export * from "./FilesFieldTreeNode.vue?vue&type=script&lang=js&"
import style0 from "./FilesFieldTreeNode.vue?vue&type=style&index=0&lang=css&"
import style1 from "./FilesFieldTreeNode.vue?vue&type=style&index=1&id=65ca0197&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ca0197",
  null
  
)

export default component.exports
import {QIcon,QBtn,QTooltip} from 'quasar'
component.options.components = Object.assign({QIcon,QBtn,QTooltip}, component.options.components || {})
